<div>
  <div class="hero"></div>
  <div>
    <div class="success-container">
      <div>
        <h3>Email Updated</h3>
        <p>
          <app-notice></app-notice>
        </p>
        <p>
          <a routerLink="/account">Back to Account</a>
        </p>
      </div>
    </div>
  </div>
</div>
